// extracted by mini-css-extract-plugin
export default {"page":"u4Hyv"};